(() => {
  const row = document.querySelector('#wd-main .ugcv-row');
  if (!row) return;
  const slides = [...row.querySelectorAll('.ugcv-slide')];
  const prev = document.getElementById('ugcvPrev');
  const next = document.getElementById('ugcvNext');
  const count = document.getElementById('wdUgcCount');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const positions = () => {
    const box = row.getBoundingClientRect();
    const max = row.scrollWidth-row.clientWidth;
    return slides.map(slide => {
      const rect=slide.getBoundingClientRect();
      return Math.max(0, Math.min(max, rect.left-box.left+row.scrollLeft+rect.width/2-row.clientWidth/2));
    });
  };
  function selected() {
    return positions().reduce((best, x, i, xs) => Math.abs(x-row.scrollLeft)<Math.abs(xs[best]-row.scrollLeft)?i:best, 0);
  }
  function sync() {
    const i = selected();
    if (count) count.textContent = `${i+1} / ${slides.length}`;
    if (prev) prev.disabled = row.scrollLeft < 2;
    if (next) next.disabled = row.scrollLeft >= row.scrollWidth-row.clientWidth-2;
  }
  function move(direction) {
    const i = Math.max(0, Math.min(slides.length-1, selected()+direction));
    row.scrollTo({ left:positions()[i], behavior:reduced.matches?'auto':'smooth' });
  }
  prev?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
  row.addEventListener('keydown', event => {
    if(event.key==='ArrowLeft'||event.key==='ArrowRight') {event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}
  });
  row.addEventListener('scroll', sync, {passive:true});
  window.addEventListener('resize', sync, {passive:true});
  sync();
})();
